import React, { useEffect, useState } from "react";
import { Content, Row, Col, Box, Button, Inputs } from "adminlte-2-react";
import _ from "lodash";
import controller from "./duck";
import { useSelector, useDispatch } from "react-redux";
import SelectInput from "../utils/SelectInput";
import "react-phone-input-2/lib/style.css";
import Multiselect from "multiselect-react-dropdown";
import TimeInput from "react-time-picker-input";
import { HexColorPicker } from "react-colorful";
import Loader from "../utils/Loader";
import ReferenciaObligatorios from "../utils/etiquetaObligatorio/ReferenciaObligatorios";
import Etiqueta from "../utils/etiquetaObligatorio/Etiqueta";
import PYG from "../utils/PYG";

const { Text } = Inputs;

const estadoOptions = () => [
  { value: "ACTIVO", label: "ACTIVO" },
  { value: "INACTIVO", label: "INACTIVO" },
];

function AddServicioHijo({ history, match }) {
  const dispatch = useDispatch();

  const modelAddServicio = useSelector((state) => state.cargarServicio);
  const modelProfesionales = useSelector(
    (state) => state.profesionalesForSelect
  );
  const modelServiciosPadre = useSelector(
    (state) => state.serviciosPadreAsOptions
  );
  const [serviciosPadreOptions, setServiciosPadreOptions] = useState([]);
  const [profesionalesOptions, setProfesionalesOptions] = useState([]);
  const [profesionales, setProfesionales] = useState([]);
  const [allSelected, setAllSelected] = useState([]);
  const [horarioTomarReserva, setHorarioTomarReserva] = useState("22:00");
  const [nombre, setNombre] = useState(null);
  const [descripcion, setDescripcion] = useState(null);
  const [precio, setPrecio] = useState(0);
  const [formattedPrecio, setFormattedPrecio] = useState("");
  const [duracion, setDuracion] = useState(null);
  const [estado, setEstado] = useState("ACTIVO");
  const [localId, setLocalId] = useState(match.params.localId);
  const [servicioPadre, setServicioPadre] = useState(null);
  const [direccionNecesaria, setDireccionNecesaria] = useState(false);
  const [maxPersonas, setMaxPersonas] = useState(1);
  const [color, setColor] = useState("#aabbcc");
  const [mostrarColorPicker, setMostrarColorPicker] = useState(false);
  const [horarioMaximoReservar, setHorarioMaximoReservar] = useState("00:00");
  const [tiempoEntreTurnos, setTiempoEntreTurnos] = useState("");

  useEffect(() => {
    const data = modelProfesionales?.data?.data?.data;
    const error = modelProfesionales?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.duckProfesionalesForSelect.actions.clear());
    }
    if (data) {
      const all = {
        value: "ALL",
        label: "Seleccionar todos",
      };
      const allValues = data.map((row) => row.value);
      setAllSelected(allValues);
      // data.unshift(all);
      setProfesionalesOptions(data);

      dispatch(controller.duckProfesionalesForSelect.actions.clear());
    }
  }, [modelProfesionales]);

  useEffect(() => {
    const data = modelServiciosPadre?.data?.data?.data;
    const error = modelServiciosPadre?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.duckServiciosPadreAsOptions.actions.clear());
    }
    if (data) {
      setServiciosPadreOptions(data);
      dispatch(controller.duckServiciosPadreAsOptions.actions.clear());
    }
  }, [modelServiciosPadre]);

  useEffect(() => {
    if (match.params.categoriaId === "60f806a5e3e9af972fe85c7a") {
      dispatch(
        controller.profesionalesForSelectThunk(match.params.localId, true)
      );
    } else {
      dispatch(controller.profesionalesForSelectThunk(match.params.localId));
    }

    dispatch(controller.serviciosPadreAsOptionsThunk(match.params.localId));
  }, []);

  useEffect(() => {
    const data = modelAddServicio?.data?.data;
    const error = modelAddServicio?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.duck.actions.clear());
    }
    if (data) {
      history.push(
        `/serviciosHijosList/${match.params.localId}/${match.params.padreId}/${match.params.categoriaId}`
      );
      dispatch(controller.duck.actions.clear());
    }
  }, [modelAddServicio]);

  function submit() {
    if (
      match.params.categoriaId !== "60f806a5e3e9af972fe85c7a" &&
      (!nombre ||
        !descripcion ||
        profesionales.length === 0 ||
        !Number(precio) < 0 ||
        !duracion ||
        duracion < 1 ||
        !estado ||
        !localId ||
        // !servicioPadre ||
        !maxPersonas)
    ) {
      alert("Por favor complete todos los campos");
      return;
    }

    if (
      match.params.categoriaId === "60f806a5e3e9af972fe85c7a" &&
      (!nombre ||
        !descripcion ||
        !profesionales.length === 0 ||
        !estado ||
        !localId)
    ) {
      alert("Por favor complete todos los campos");
      return;
    }

    const arrayProfesionalesValue = [];
    profesionales.forEach((row, index) => {
      arrayProfesionalesValue.push(row.value);
    });
    let data = {
      nombre,
      horarioTomarReserva,
      descripcion,
      precio,
      duracion,
      estado,
      localId,
      servicioPadre: match.params.padreId,
      direccionNecesaria,
      maxPersonas,
      profesionales: arrayProfesionalesValue,
      color: mostrarColorPicker ? color : null,
      horarioMaximoReservar,
      tiempoEntreTurnos,
    };

    dispatch(controller.cargarServicioThunk(data));
  }

  return (
    <Content title="Nuevo servicio" browserTitle="Nuevo servicio" show={false}>
      <Row>
        <Col md="4" mdOffset="4">
          <Box
            title="Nuevo servicio"
            footer={
              <>
                <Button
                  text="Cancelar"
                  disabled={false}
                  onClick={() => {
                    history.push(
                      `/serviciosHijosList/${match.params.localId}/${match.params.padreId}/${match.params.categoriaId}`
                    );
                  }}
                />
                <Button
                  type="primary"
                  text={
                    <Loader
                      loaderColor="#ffffff"
                      isLoading={modelAddServicio.loading}
                    >
                      Guardar
                    </Loader>
                  }
                  pullRight={true}
                  disabled={modelAddServicio.loading}
                  onClick={() => submit()}
                />
              </>
            }
          >
            <ReferenciaObligatorios />

            <SelectInput
              value={estado}
              setValue={setEstado}
              label="Estado"
              options={estadoOptions()}
            />

            <Text
              labelPosition="above"
              size="sm"
              label={<Etiqueta texto="Nombre" obligatorio={true} />}
              value={nombre}
              onChange={(evt) => setNombre(evt.target.value)}
            />

            <Text
              labelPosition="above"
              size="sm"
              label={<Etiqueta texto="Descripción" obligatorio={true} />}
              value={descripcion}
              onChange={(evt) => setDescripcion(evt.target.value)}
            />

            {match.params.categoriaId !== "60f806a5e3e9af972fe85c7a" ? (
              <>
                <PYG
                  // react-number-format's props
                  value={precio}
                  isNumericString={true}
                  displayType="input"
                  onValueChange={(values) => {
                    const { formattedValue, value } = values;
                    setPrecio(value);
                  }}
                  decimalScale={0}
                  customInput={Text}
                  // adminlte-2-react's Text's props
                  labelPosition="above"
                  size="sm"
                  label={<Etiqueta texto="Precio" obligatorio={true} />}
                />

                <Text
                  inputType="number"
                  labelPosition="above"
                  size="sm"
                  label={
                    <Etiqueta texto="Duración en minutos" obligatorio={true} />
                  }
                  value={duracion}
                  onChange={(evt) => setDuracion(evt.target.value)}
                />

                <Text
                  inputType="number"
                  labelPosition="above"
                  size="sm"
                  label={
                    <Etiqueta texto="Tiempo entre turnos" obligatorio={true} />
                  }
                  value={tiempoEntreTurnos}
                  onChange={(evt) => setTiempoEntreTurnos(evt.target.value)}
                />

                <Text
                  inputType="number"
                  labelPosition="above"
                  size="sm"
                  label={
                    <Etiqueta
                      texto="Máximo de personas por sesión"
                      obligatorio={true}
                    />
                  }
                  value={maxPersonas}
                  onChange={(evt) => setMaxPersonas(evt.target.value)}
                />
              </>
            ) : null}

            {match.params.categoriaId === "60f806a5e3e9af972fe85c7a" ? (
              <>
                <text>
                  <strong>Hora maxima para tomar reserva</strong>
                </text>
                <TimeInput
                  value={horarioTomarReserva}
                  onChange={setHorarioTomarReserva}
                />
                <text>
                  <strong>Hora maxima para realizar reserva</strong>
                </text>
                <TimeInput
                  value={horarioMaximoReservar}
                  onChange={setHorarioMaximoReservar}
                />
              </>
            ) : (
              <Text
                inputType="number"
                labelPosition="above"
                size="sm"
                label={
                  <Etiqueta texto="Minutos depues de la hora actual para mostrar disponibilidades" />
                }
                value={horarioMaximoReservar}
                onChange={(evt) => setHorarioMaximoReservar(evt.target.value)}
              />
            )}

            <label>
              <Etiqueta
                texto={
                  match.params.categoriaId === "60f806a5e3e9af972fe85c7a"
                    ? "Ambientes"
                    : "Profesionales"
                }
                obligatorio={true}
              />
            </label>

            <Multiselect
              hidePlaceholder={true}
              options={profesionalesOptions}
              selectedValues={profesionales}
              onSelect={(selectedList, selectedItem) => {
                setProfesionales([...profesionales, selectedItem]);
              }}
              onRemove={(selectedList, removedItem) => {
                setProfesionales(selectedList);
              }}
              displayValue="label"
            />

            <div className="checkbox">
              <label>
                <input
                  type="checkbox"
                  onChange={() => setMostrarColorPicker(!mostrarColorPicker)}
                  checked={mostrarColorPicker}
                />{" "}
                Definir color para calendario
              </label>
            </div>

            {mostrarColorPicker && (
              <HexColorPicker color={color} onChange={setColor} />
            )}
          </Box>
        </Col>
      </Row>
    </Content>
  );
}

export default AddServicioHijo;
